import useRebrandVersion from 'hooks/useRebrandVersion'

type RebrandSuccessDarkColour = Extract<App.Design.ContentColour, 'success-dark' | 'highlight-primary-dark'>

/**
 * Rebrand remaps highlight-primary-dark to ocean. Surfaces that should keep the
 * legacy brand-green treatment use messaging success dark instead.
 *
 * For borders and PromotionLabel premium fills, also use the shared CSS bridges in
 * `lib/theme/rebrandSuccessDarkStyles` so JSX colour and CSS stay on the same tokens.
 */
function useRebrandSuccessDarkColour(): RebrandSuccessDarkColour {
  return useRebrandVersion() === 'rebrand' ? 'success-dark' : 'highlight-primary-dark'
}

export default useRebrandSuccessDarkColour
